import React, { Component } from 'react'
import update from 'immutability-helper'
import { Accordion, Icon, Button, Divider} from 'semantic-ui-react'
import AccordionListContent from './AccordionListContent'
import { API_APPROVE_GROUP, API_REJECT_GROUP } from '../../api'
import find from 'lodash.find'
import result from 'lodash.result'
import { map, filter } from 'lodash'

export default class AccordionList extends Component {
  constructor(props){
    super(props);
    this.state = {
      indexGroup: 0,
      dataGroups: [{
        fields: []
      }],
      userID: null,
      imageKTP: null
    }
  }

  initialData = (props) => {
    const ktpGroup = find(props.propsGroup, group => group.groupCode === 'ktp')
    let imageKTP = 'https://dummyimage.com/400x500/dddddd/c5c5c7&text=Data+Kosong'
    if (ktpGroup){
      imageKTP = result(
        find(ktpGroup.fields, field => field.fieldCode === 'ktp_url'),
        'fieldValue'
      )
    }

    const dataGroups = map(props.propsGroup, group => ({ ...group, fields: filter(group.fields, field => field.fieldVisibleToUser)}));

    this.setState({
      dataGroups,
      userID: props.propsUserID,
      imageKTP
    })
  }

  componentDidMount() {
    this.initialData(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.initialData(nextProps)
  }

  setGroupStatus = (status) => {
    if (status === 'verified') {
      return ( <Icon name='check circle' color='green'/> )
    }else if (status === 'new') {
      return ( <Icon name='sticky note outline' color='teal'/> )
    }else if (status === 'pending') {
      return ( <Icon name='warning circle' color='yellow'/> )
    }else if (status === 'process') {
      return ( <Icon name='hourglass end' color='blue'/> )
    }else {
      return ( <Icon name='minus circle' color='red'/> )
    }
  }

  /* =========================================
  :: Handle Function
  ==========================================*/

  handleClickAccordion = (e, titleProps) => {
    e.preventDefault()
    const { index } = titleProps
    const { indexGroup } = this.state
    const newIndex = indexGroup === index ? -1 : index

    this.setState({ indexGroup: newIndex })
    window.scrollTo(1000, 0)
  }

  handleButtonRejectGroup = (varIndexField, getstatus) => {
    const { indexGroup } = this.state

    this.setState(state => ({
      dataGroups: update(this.state.dataGroups, {
        [indexGroup]: {
          fields: {
            [varIndexField] :
              { status: { $set: 'failed' }, failureReason: { $set: getstatus } }
          }
        }
      })
    }))
  }

  handleButtonApproveGroup = (varIndexField, getstatus) => {
    const { indexGroup } = this.state

    this.setState(state => ({
      dataGroups: update(this.state.dataGroups, {
        [indexGroup]: {
          fields:{
            [varIndexField]:
              { status: { $set: 'verified' }, failureReason: { $set: null } }
          }
        }
      })
    }))
  }

  handleButtonSubmitGroup = (e) => {
    e.preventDefault()
    const { indexGroup, dataGroups, userID } = this.state
    const newIndex = indexGroup + 1
    let failures = {
      failureReasons: []
    }

    dataGroups[indexGroup].fields.map((res, i) => {
      if (res.status === 'failed' || res.status === 'pending') {
        const reason = {
          fieldCode: res.fieldCode,
          failureReason: res.failureReason
        }
        failures.failureReasons.push(reason)
      }
      return 0
    })

    let paramGroup = {
      userId: userID,
      groupCode: dataGroups[indexGroup].groupCode
    }

    if(failures.failureReasons.length > 0 ){
      API_REJECT_GROUP(paramGroup, failures)
        .then( () => {
          this.setState( () => ({
            dataGroups: update(this.state.dataGroups, {
              [indexGroup]: { groupStatus: { $set: 'failed' } }
            }),
            indexGroup: newIndex
          }))
        })
        .catch( () => {
          this.props.enableModalError()
        })  
    }else{
      API_APPROVE_GROUP(paramGroup)
        .then( () => {
          this.setState( () => ({
            dataGroups: update(this.state.dataGroups, {
              [indexGroup]: { groupStatus: { $set: 'verified' } }
            }),
            indexGroup: newIndex
          }))
        })
        .catch( () => {
          this.props.enableModalError()
        })
    }

    window.scrollTo(1000, 0)
  }

  handleButtonVerify = (e) => {
    e.preventDefault()
    this.setState({ indexGroup: 0})
    this.props.propsButtonVerify()
  }

  /* =========================================
  :: Render
  ==========================================*/

  render() {
    const { indexGroup, dataGroups, imageKTP } = this.state
    let disableButtonVerify = true

    dataGroups.map(group => {
      return group.groupStatus === 'new' || group.groupStatus === 'pending' ||  group.groupStatus === 'process' ? disableButtonVerify = true : disableButtonVerify = false
    })

    return (
      <div>
        <Accordion fluid styled>
          {
            dataGroups.map( (group, key ) => {
              let disableButtonGroup = true

              group.fields.map(arr => {
                return arr.status === 'failed' || arr.status === 'verified' || arr.status === 'pending' ? disableButtonGroup = false : disableButtonGroup = true
              })

              return (
                <div key={key}>
                  <Accordion.Title active={indexGroup === key} index={key} onClick={this.handleClickAccordion}>
                    {this.setGroupStatus(group.groupStatus)} {group.groupName}
                  </Accordion.Title>
                  <Accordion.Content active={indexGroup === key}>
                    {
                      group.fields.map( (field, keyFields) =>
                        <AccordionListContent
                          key={keyFields}
                          propsKey={keyFields}
                          propsData={field}
                          propsKTP={imageKTP}
                          propsStatusReject={this.handleButtonRejectGroup}
                          propsStatusApprove={this.handleButtonApproveGroup}
                        />
                      )
                    }
                    <Divider section />

                    <Button primary fluid onClick={this.handleButtonSubmitGroup} disabled={disableButtonGroup}>
                      PROCESS
                    </Button>
                  </Accordion.Content>
                </div>
              )
            })
          }
      </Accordion>

      {/* Button Finish Verify */}
      <Divider section />
      <Button onClick={this.handleButtonVerify} size='big' fluid positive disabled={disableButtonVerify}>FINISH VERIFY</Button>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/component/Verification/AccordionList.js